<script>
import "@plugins/fancybox/jquery.fancybox.css"
import "@plugins/fancybox/jquery.fancybox.js"

export default {
  props: {
    title: {default:"Image Preview"},
    rel: String,
    src: String,
  },
  computed:{
    uploader(){ return this.$root.page.uploader }
  },
  mounted: function(){
    if(!this.rel){
      $(this.$el).fancybox();
    }else{
      setTimeout(()=>{
        $("[rel="+this.rel+"]").fancybox();
      }, 300)
    }
  },
}
</script>

<template>
  <a :href="src" :rel="rel" class="btn btn-info" v-tooltip="title"><i class="ti-image"></i></a>
</template>

